import { FC, useState } from 'react'

import './tooltip.css'

type tooltipProps = {
  text: string | JSX.Element | Element
  className?: string
}

const Tooltip: FC<tooltipProps> = ({ text, className, children }) => {
  const [active, setActive] = useState(false)

  return (
    <div className="tooltip-wrapper" onMouseEnter={() => setActive(true)} onMouseLeave={() => setActive(false)}>
      {children}
      {active && <div className={`tooltip ${className || ''}`}>{text}</div>}
    </div>
  )
}

export default Tooltip
